module.exports = __webpack_public_path__ + "static/media/blob-shape-1.2ba93715.svg";